import * as React from 'react';
import { connect } from 'react-redux';
import {
  SettingTabPanelList,
  SettingTabPanelListRow,
  SettingTabPanelListRowImageTitle,
} from '../../common/SettingTabPanelList';
import ToolIconRadioButtonSet from '../../common/ToolIconRadioButtonSet';
import { Dispatch, Action } from 'redux';
import { AppStates } from '../../../reducers/app';
import { LineStyle } from '../../../reducers/ui/ui';
import { LineType } from '../../../drawing/types';
import FreehandPenUIAction from '../../../actions/ui/FreehandPenUIAction';
import { FreehandPenState } from '../../../reducers/ui/freehandPen';
import { Color } from '../../../types/color';
import { FreehandPenWidth } from '../../../types/freehandPenWidth';
import SelectableColorIconButton from '../../common/SelectableIconButton/SelectableColorIconButton';
import SelectableNormalIconButton
from '../../common/SelectableIconButton/SelectableNormalIconButton';
import SelectableRectangleIconButton
from '../../common/SelectableIconButton/SelectableRectangleIconButton';

interface FreehandPenSettingPanelProps extends FreehandPenState {
  readonly dispatch: Dispatch<Action>;
}

const borderStyle: React.CSSProperties = {
  width: '100%',
  height: 2,
  backgroundColor: '#bebebe',
  border: 0,
  margin: 0,
};

const titleContainerStyle: React.CSSProperties = {
  width: '118px',
  flexShrink: 0,
};

const titleStyle: React.CSSProperties = {
  width: '70px',
};

const largeButtonContainerStyle: React.CSSProperties = {
  width: '86px',
  height: '52px',
  marginLeft: '10px',
  marginRight: '10px',
};

const FreehandPenSettingPanel: React.SFC<FreehandPenSettingPanelProps> = React.memo((props) => {
  const { selected, toolSettings, dispatch } = props;

  return (
    <SettingTabPanelList style={{ padding: 0 }}>
      <SettingTabPanelListRow>
        <SettingTabPanelListRowImageTitle
          imgName="text_pen_color"
          containerStyle={titleContainerStyle}
          imageStyle={titleStyle} />
        <ToolIconRadioButtonSet style={{ width: '340px' }}>
          <SelectableColorIconButton
            title="赤"
            imagePath="images/setting-popup/color/btn_color_red_01"
            active={toolSettings[selected].color === Color.Red}
            onClick={() => {
              FreehandPenUIAction.setPenColor(selected, Color.Red, dispatch);
            }} />
          <SelectableColorIconButton
            title="青"
            imagePath="images/setting-popup/color/btn_color_blue_01"
            active={toolSettings[selected].color === Color.Blue}
            onClick={() => {
              FreehandPenUIAction.setPenColor(selected, Color.Blue, dispatch);
            }} />
          <SelectableColorIconButton
            title="黄色"
            imagePath="images/setting-popup/color/btn_color_yellow_01"
            active={toolSettings[selected].color === Color.Yellow}
            onClick={() => {
              FreehandPenUIAction.setPenColor(selected, Color.Yellow, dispatch);
            }} />
          <SelectableColorIconButton
            title="緑"
            imagePath="images/setting-popup/color/btn_color_green_01"
            active={toolSettings[selected].color === Color.Green}
            onClick={() => {
              FreehandPenUIAction.setPenColor(selected, Color.Green, dispatch);
            }} />
          <SelectableColorIconButton
            title="黒"
            imagePath="images/setting-popup/color/btn_color_black_01"
            active={toolSettings[selected].color === Color.Black}
            onClick={() => {
              FreehandPenUIAction.setPenColor(selected, Color.Black, dispatch);
            }} />
          <SelectableColorIconButton
            title="半透明_赤"
            imagePath="images/setting-popup/color/btn_color_red_02"
            active={toolSettings[selected].color === Color.RedTransparent}
            onClick={() => {
              FreehandPenUIAction.setPenColor(selected, Color.RedTransparent, dispatch);
            }} />
          <SelectableColorIconButton
            title="半透明_青"
            imagePath="images/setting-popup/color/btn_color_blue_02"
            active={toolSettings[selected].color === Color.BlueTransparent}
            onClick={() => {
              FreehandPenUIAction.setPenColor(selected, Color.BlueTransparent, dispatch);
            }} />
          <SelectableColorIconButton
            title="半透明_黄色"
            imagePath="images/setting-popup/color/btn_color_yellow_02"
            active={toolSettings[selected].color === Color.YellowTransparent}
            onClick={() => {
              FreehandPenUIAction.setPenColor(selected, Color.YellowTransparent, dispatch);
            }} />
          <SelectableColorIconButton
            title="半透明_緑"
            imagePath="images/setting-popup/color/btn_color_green_02"
            active={toolSettings[selected].color === Color.GreenTransparent}
            onClick={() => {
              FreehandPenUIAction.setPenColor(selected, Color.GreenTransparent, dispatch);
            }} />
          <SelectableColorIconButton
            title="半透明_黒"
            imagePath="images/setting-popup/color/btn_color_black_02"
            active={toolSettings[selected].color === Color.BlackTransparent}
            onClick={() => {
              FreehandPenUIAction.setPenColor(selected, Color.BlackTransparent, dispatch);
            }} />
        </ToolIconRadioButtonSet>
      </SettingTabPanelListRow>

      <hr style={borderStyle} />

      <SettingTabPanelListRow>
        <SettingTabPanelListRowImageTitle
          imgName="text_pen_line_size"
          containerStyle={titleContainerStyle}
          imageStyle={titleStyle} />
        <ToolIconRadioButtonSet>
          <SelectableNormalIconButton
            title="1"
            imagePath="images/setting-popup/line-size/btn_line_size_01"
            active={toolSettings[selected].width === FreehandPenWidth.one}
            onClick={() => {
              FreehandPenUIAction.setWidth(selected, FreehandPenWidth.one, dispatch);
            }} />
          <SelectableNormalIconButton
            title="2"
            imagePath="images/setting-popup/line-size/btn_line_size_02"
            active={toolSettings[selected].width === FreehandPenWidth.two}
            onClick={() => {
              FreehandPenUIAction.setWidth(selected, FreehandPenWidth.two, dispatch);
            }} />
          <SelectableNormalIconButton
            title="3"
            imagePath="images/setting-popup/line-size/btn_line_size_03"
            active={toolSettings[selected].width === FreehandPenWidth.three}
            onClick={() => {
              FreehandPenUIAction.setWidth(selected, FreehandPenWidth.three, dispatch);
            }}  />
          <SelectableNormalIconButton
            title="4"
            imagePath="images/setting-popup/line-size/btn_line_size_04"
            active={toolSettings[selected].width === FreehandPenWidth.four}
            onClick={() => {
              FreehandPenUIAction.setWidth(selected, FreehandPenWidth.four, dispatch);
            }} />
          <SelectableNormalIconButton
            title="5"
            imagePath="images/setting-popup/line-size/btn_line_size_05"
            active={toolSettings[selected].width === FreehandPenWidth.five}
            onClick={() => {
              FreehandPenUIAction.setWidth(selected, FreehandPenWidth.five, dispatch);
            }} />
        </ToolIconRadioButtonSet>
      </SettingTabPanelListRow>

      <hr style={borderStyle} />

      <SettingTabPanelListRow>
        <SettingTabPanelListRowImageTitle
          imgName="text_pen_line_type_01"
          containerStyle={titleContainerStyle}
          imageStyle={titleStyle} />
        <ToolIconRadioButtonSet style={{ justifyContent: 'center', width: '100%' }}>
          <SelectableNormalIconButton
            title="実線"
            imagePath="images/setting-popup/line-type/btn_line_type_01"
            active={toolSettings[selected].lineType === LineType.Solid}
            onClick={() => {
              FreehandPenUIAction.setLineType(selected, LineType.Solid, dispatch);
            }} />
          <SelectableNormalIconButton
            title="破線"
            imagePath="images/setting-popup/line-type/btn_line_type_02"
            active={toolSettings[selected].lineType === LineType.Dashed}
            onClick={() => {
              FreehandPenUIAction.setLineType(selected, LineType.Dashed, dispatch);
            }} />
        </ToolIconRadioButtonSet>
      </SettingTabPanelListRow>

      <hr style={borderStyle} />

      <SettingTabPanelListRow>
        <SettingTabPanelListRowImageTitle
          imgName="text_pen_line_type_02"
          containerStyle={titleContainerStyle}
          imageStyle={titleStyle} />
        <ToolIconRadioButtonSet style={{ justifyContent: 'center', width: '100%' }}>
          <SelectableRectangleIconButton
            title="自由"
            imagePath="images/setting-popup/line-type/btn_line_type_03"
            containerStyle={largeButtonContainerStyle}
            active={toolSettings[selected].lineStyle === LineStyle.Freehand}
            onClick={() => {
              FreehandPenUIAction.setLineStyle(selected, LineStyle.Freehand, dispatch);
            }} />
          <SelectableRectangleIconButton
            title="水平直線"
            imagePath="images/setting-popup/line-type/btn_line_type_04"
            containerStyle={largeButtonContainerStyle}
            active={toolSettings[selected].lineStyle === LineStyle.HorizontalAxisAligned}
            onClick={() => {
              FreehandPenUIAction.setLineStyle(selected, LineStyle.HorizontalAxisAligned, dispatch);
            }} />
          <SelectableRectangleIconButton
            title="垂直直線"
            imagePath="images/setting-popup/line-type/btn_line_type_05"
            containerStyle={largeButtonContainerStyle}
            active={toolSettings[selected].lineStyle === LineStyle.VerticalAxisAligned}
            onClick={() => {
              FreehandPenUIAction.setLineStyle(selected, LineStyle.VerticalAxisAligned, dispatch);
            }} />
        </ToolIconRadioButtonSet>
      </SettingTabPanelListRow>
    </SettingTabPanelList>
  );
});

const mapStateToProps = (appStates: AppStates) => ({ ...appStates.ui.freehandPen });

export default connect(mapStateToProps)(FreehandPenSettingPanel);
